<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('utils.lunlog19')"
      @backurl="$router.back()"
    />
    
    <div class="main_content">
      <div class="card_box form_card">
        <div class="form_title">{{ $t('utils.lunlog19') }}</div>
        
        <form class="form" @submit.prevent="submit">
          
          <!-- 1. 邮箱 (只读) -->
          <div class="input_wrap readonly">
            <input
              v-model.trim="email"
              type="text"
              class="inp"
              :placeholder="$t('auth.emailEmpty')"
              readonly
            >
          </div>

          <!-- 2. 验证码 + 获取按钮 -->
          <div class="code_row">
            <div class="input_wrap code_input">
              <input
                v-model.trim="code"
                type="text"
                class="inp"
                :placeholder="$t('auth.emailCode')"
              >
            </div>
            <van-count-down
              :time="time"
              class="get_captcha_btn"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span 
                  class="send_btn"
                  :class="{ disabled: is_send || timeData.seconds > 0 }"
                  @click="sendcode"
                >
                  {{ timeData.seconds > 0 ? timeData.seconds + 's' : $t('auth.sendEmailCode') }}
                </span>
              </template>
            </van-count-down>
          </div>

          <!-- 3. 新密码 -->
          <div class="input_wrap">
            <input
              v-model.trim="newpwd"
              type="password"
              class="inp"
              :placeholder="$t('utils.lunlog20')"
            >
          </div>

          <!-- 4. 确认密码 -->
          <div class="input_wrap">
            <input
              v-model.trim="conpwd"
              type="password"
              class="inp"
              :placeholder="$t('utils.lunlog23')"
            >
          </div>

          <!-- 5. 提交按钮 -->
          <button
            type="submit"
            class="submit_btn"
            :class="newpwd && conpwd ? '' : 'disabled'"
          >
            {{ $t('utils.confirm') }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox } from "vant";
import Fetch from '../../utils/fetch';
import bsHeader from '../../components/bsHeader.vue';
Vue.use(CountDown).use(Checkbox);

export default {
  name: "Setpwd",
  components: { bsHeader },
  data() {
    return {
      data: {},
      time: 0,
      email: '',
      pwd:'',
      code: '',
      oldpwd:'',
      newpwd:'',
      conpwd:'',
      is_send: false
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/getAuthStatus').then((r) => {
        this.data = r.data; 
        this.email = r.data.email;
      });
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) return false;
      if (!this.email) {
        this.$toast(this.$t('auth.emailEmpty'));
        return false;
      }
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.email)) {
        this.$toast(this.$t('auth.emailError'));
        return false;
      }
      this.is_send = true;
      Fetch("/user/getEmailCode", { email: this.email }).then(() => {
        this.time = 60 * 1000;
        this.$toast({ background: "#07c160", message: this.$t('auth.sendsuccess') });
      }).catch(() => {
        this.is_send = false;
      });
    },
    submit() {
      if (!this.newpwd) {
        this.$toast(this.$t('utils.lunlog20'));
        return false;
      }
      if (!this.conpwd) {
        this.$toast(this.$t('utils.lunlog23'));
        return false;
      }
      if (this.newpwd != this.conpwd) {
        this.$toast(this.$t('utils.lunlog24'));
        return false;
      }
      Fetch('/user/setpwd', {
        oldpwd: this.oldpwd,
        newpwd: this.newpwd,
        conpwd: this.conpwd,
        code: this.code
      }).then(r => {
        if(r.code == '218'){
          this.$toast(this.$t(r.info));
          return false;
        } else {
          this.$toast({ background: '#07c160', message: this.$t('utils.lunlog26') });
          this.$router.replace('/user')
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding-bottom: 60px;
  /* 浅蓝网格背景 */
  background-color: #f0f4fa;
  background-image: linear-gradient(#dce5ef 1px, transparent 1px), linear-gradient(90deg, #dce5ef 1px, transparent 1px);
  background-size: 20px 20px;
}

.main_content {
  padding: 16px;
  display: flex;
  justify-content: center;
}

/* ================= 白色表单卡片 ================= */
.card_box {
  background: #ffffff;
  border-radius: 18px;
  padding: 24px 20px 30px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  border: 1px solid rgba(176, 202, 240, 0.3);

  .form_title {
    font-size: 22px;
    font-weight: 700;
    color: #1a2742;
    margin-bottom: 20px;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}

/* ================= 输入框通用样式 ================= */
.input_wrap {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  padding: 0 12px;
  transition: border-color 0.2s;

  &.readonly {
    background: #f8fafc;
  }

  .inp {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #1a2742;
    &::placeholder { color: #94a3b8; }
    &:read-only { color: #64748b; }
  }
}

/* ================= 验证码行 ================= */
.code_row {
  display: flex;
  gap: 10px;
  align-items: stretch;

  .code_input {
    flex: 1;
  }

  .get_captcha_btn {
    display: flex;
    align-items: center;
  }

  .send_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 14px;
    background: #eff6ff;
    color: #2563eb;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s;
    
    &:active { opacity: 0.8; }
    &.disabled {
      background: #f1f5f9;
      color: #94a3b8;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
}

/* ================= 提交按钮 ================= */
.submit_btn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: none;
  background: linear-gradient(135deg, #77a8ff 0%, #4e7dff 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 6px;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
  transition: all 0.2s;
  
  &:active { transform: scale(0.96); }
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>